import { getInstance, DOMAIN_ENV } from '@finance/domain'

// 当前环境
export const ENV = getInstance().env

// 是否正式环境
export const isPROD = ENV === DOMAIN_ENV.PROD || ENV === DOMAIN_ENV.OUTER_PROD
